export default __webpack_public_path__ + "bac4654b639eb739577d44b59b4e1706.png";